export const CandidateFieldRenderer = ({
  field,
  context,
  getUdfValue = (f) => f.udfData.value,
}) => {
  const newFieldDef = {
    ...field,
    ...(field.isUDF
      ? { udfData: { ...field.udfData, value: getUdfValue(field) } }
      : {}),
  };

  const FieldComponent = field.component;
  const fieldProps = field.getProps(context, newFieldDef);

  return <FieldComponent {...fieldProps} />;
};
